import {
  POSITION_LOADING,
  GET_POSITION,
  GET_STRUCTURE,
  GET_POSITION_SUCCESS,
  GET_POSITION_FAIL,
  ADD_POSITION_SUCCESS,
  ADD_POSITION_FAIL,
  DELETE_POSITION_SUCCESS,
  DELETE_POSITION_FAIL,
  UPDATE_POSITION_SUCCESS,
  UPDATE_POSITION_FAIL,
  POSITION_RESET
} from "./actionType";

const INIT_STATE = {
  positions: [],
  structures: [],
  error: {},
};

const Position = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_POSITION_SUCCESS:
      switch (action.payload.actionType) {
        case GET_POSITION:
          return {
            ...state,
            positions: action.payload.data,
            isPositionCreated: false,
            isPositionSuccess: true,
            loading: false,
          };

        case GET_STRUCTURE:
          return {
            ...state,
            structures: action.payload.data,
            isPositionCreated: false,
            isPositionSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_POSITION_FAIL:
      switch (action.payload.actionType) {
        case GET_POSITION_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isPositionCreated: false,
            isPositionSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_POSITION: {
      return {
        ...state,
        isPositionCreated: false,
        loading: true,
      };
    }

    case POSITION_LOADING: {
      return {
        ...state,
        isPositionCreated: false,
        loading: true,
      };
    }

    case ADD_POSITION_SUCCESS:
      return {
        ...state,
        isPositionCreated: true,
        loading: false,
        positions: [action.payload.data, ...state.positions],
      };

    case ADD_POSITION_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_POSITION_SUCCESS:
      return {
        ...state,
        loading: false,
        positions: state.positions.filter(
          position => position.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_POSITION_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_POSITION_SUCCESS:
      return {
        ...state,
        loading: false,
        positions: state.positions.map(position =>
          position.id.toString() === action.payload.data.id.toString() ? { ...position, ...action.payload.data } : position
        ),
      };

    case UPDATE_POSITION_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case POSITION_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default Position;